// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__radioGroup--KXruE {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Settings/Planning2Settings.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AACF","sourcesContent":[".radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioGroup": `src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__radioGroup--KXruE`
};
export default ___CSS_LOADER_EXPORT___;
